import React from 'react';

import { SvgIcon, type SvgIconProps } from '@mui/material';

import { BRAND_COLORS } from '~/components/brand/brandTokens';

export interface RichardMonogramProps extends SvgIconProps {
  /** Renders the inverted pair (Compass White circle, Ocean Teal R) for placement on an Ocean Teal field. */
  inverted?: boolean;
}

/** Shared source geometry for the R mark, without the avatar circle. */
export function renderRMonogramPaths(fill: string) {
  return (
    <g transform="translate(24,24) scale(0.104)" fill={fill} fillRule="evenodd">
      <path d="M9.1,9.1 L320.2,9.1 L320.2,158.6 L9.1,158.6 Z" />
      <path d="M342.8,9.1 L344.4,10.6 L368.5,12.1 L397.2,21.1 L424.4,36.2 L451.6,60.4 L466.7,81.6 L478.8,107.2 L486.3,135.9 L487.8,158.6 L341.3,158.6 L341.3,10.6 Z" />
      <path d="M9.1,179.7 L158.6,179.7 L158.6,329.3 L9.1,329.3 Z" />
      <path d="M179.7,179.7 L487.8,179.7 L487.8,190.3 L480.3,226.5 L465.2,258.3 L439.5,288.5 L412.3,308.1 L394.2,317.2 L365.5,326.2 L342.8,327.7 L341.3,329.3 L179.7,329.3 Z" />
      <path d="M392.7,342.8 L397.2,342.8 L403.3,350.4 L404.8,354.9 L409.3,359.5 L410.8,364.0 L501.4,498.4 L356.4,498.4 L347.4,495.4 L335.3,487.8 L327.7,478.8 L259.8,350.4 L347.4,350.4 L348.9,348.9 L377.6,347.4 L392.7,342.8 Z" />
      <path d="M9.1,350.4 L158.6,350.4 L158.6,498.4 L9.1,498.4 Z" />
    </g>
  );
}

/**
 * The askRichard R avatar: a self-contained mark on a 100-unit grid. The
 * circle and the R carry their own brand colour, so the mark reads
 * correctly wherever it sits rather than inheriting `currentColor` from an
 * ancestor (an Avatar's bgcolor, a themed icon button, dark mode text
 * colour). The six R paths are the unchanged source geometry, placed at
 * translate(24,24) scale(0.104) inside the circle. Never scaled to fill,
 * never a squircle, never paired with the wordmark.
 */
export default function RichardMonogram({ inverted = false, ...props }: RichardMonogramProps) {
  const circleFill = inverted ? BRAND_COLORS.compassWhite : BRAND_COLORS.oceanTeal;
  const markFill = inverted ? BRAND_COLORS.oceanTeal : BRAND_COLORS.compassWhite;

  return (
    <SvgIcon viewBox="0 0 100 100" {...props}>
      <circle cx="50" cy="50" r="50" fill={circleFill} />
      {renderRMonogramPaths(markFill)}
    </SvgIcon>
  );
}
